import { gameComputedProperties } from './features/game/game.computedProperties';

export const computedProperties = {
  ...gameComputedProperties,
};

export default computedProperties;
